import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { firebaseConfig } from './config';

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Debug: Check environment variables
const useEmulator = import.meta.env.VITE_USE_FIREBASE_EMULATOR;
console.log('Environment check:', {
  VITE_USE_FIREBASE_EMULATOR: useEmulator,
  NODE_ENV: import.meta.env.NODE_ENV,
  MODE: import.meta.env.MODE
});

// FORCE PRODUCTION MODE - Do not connect to emulators
const shouldUseEmulator = false; // Hardcoded to false for production

console.log('Emulator decision:', {
  shouldUseEmulator,
  useEmulator,
  type: typeof useEmulator,
  forced: 'production mode'
});

if (shouldUseEmulator) {
  try {
    // Only connect if not already connected
    const authEmulatorUrl = import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_URL || 'http://localhost:9099';
    
    connectAuthEmulator(auth, authEmulatorUrl);
    connectFirestoreEmulator(db, 'localhost', 8080);
    console.log('🔧 Connected to Firebase emulators');
  } catch (error) {
    console.log('Firebase emulators not running, using production', error);
  }
} else {
  console.log('🚀 Using production Firebase services - emulator FORCED OFF');
}
